import * as UpdateAmountInvestmentTypes from 'src/actions/update-amount/Types';
import { UpdateAmountInvestmentAction }
  from 'src/actions/update-amount/UpdateAmountInvestment.actions';

export interface UpdateAmountInvestmentState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: UpdateAmountInvestmentState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function UpdateAmountInvestmentReducer(
  state: UpdateAmountInvestmentState = initialState,
  action: UpdateAmountInvestmentAction): UpdateAmountInvestmentState {

  switch (action.type) {
    case UpdateAmountInvestmentTypes.UPDATE_AMOUNT_INVESTMENT_ATTEMPT:
      return {...state, loading: true, error: false};
    case UpdateAmountInvestmentTypes.UPDATE_AMOUNT_INVESTMENT_SUCCESS:
      return {...state, loading: false, error: false};
    case UpdateAmountInvestmentTypes.UPDATE_AMOUNT_INVESTMENT_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/investment/UpdateAmountInvestmentReducer.tsx